var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{directives:[{name:"bg-typography",rawName:"v-bg-typography",value:('h2'),expression:"'h2'"}]},[_vm._v("\n    "+_vm._s(_vm.boldTitle)+"\n    "),_c('span',{staticClass:"page-section__normal-part"},[_vm._v(_vm._s(_vm.normalTitle))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }